<div
  class="wrapper"
  [ngClass]="{ width100: !isQuick }"
  ignoreClass="quickLoadingSpace"
  (glClickedOutside)="close()"
  >
  @if (isQuick) {
    <div class="searchWrapper">
      <gl-search-input (searchChange)="onSearch($event)" autocomplete="off"></gl-search-input>
      <div class="buttonContainer">
        <button
          class="sortButton"
          outline-icon-button
          (click)="sortByNameSwitch()"
          [class.activeSortByName]="isSortByNameEnabled"
          >
          <gl-icon class="sortIcon" [name]="'sort'"></gl-icon>
        </button>
      </div>
    </div>
  }
  <form [formGroup]="typeForm" class="formTypes" [ngClass]="{ quick: this.isQuick }" >
    <gl-button-toggle data-ctx="button-toggle-truck" [name]="'type'" [value]="1" formControlName="type">
      <div class="toggleContent">
        <gl-icon [name]="'semi-trailer'" class="iconTypeSemiTrailer"></gl-icon>
        @if (!isQuick) {
          <span class="typeTitle">{{ 'truck' | translate }}</span>
        }
      </div>
    </gl-button-toggle>
    <div class="typeButtonsWrapper">
      <div class="typeButtonsContainer">
        <gl-button-toggle data-ctx="button-toggle-sea-container" [name]="'type'" [value]="2" formControlName="type">
          <div class="toggleContent">
            <gl-icon [name]="'container'" class="iconTypeContainer"></gl-icon>
            @if (!isQuick) {
              <span class="typeTitle">{{ 'sea_container' | translate }}</span>
            }
          </div>
        </gl-button-toggle>
        <gl-button-toggle data-ctx="button-toggle-air-container" [name]="'type'" [value]="4" formControlName="type">
          <div class="toggleContent">
            <gl-icon [name]="'airContainer'" class="iconTypeContainer"></gl-icon>
            @if (!isQuick) {
              <span  class="typeTitle">{{ 'air_container' | translate }}</span>
            }
          </div>
        </gl-button-toggle>
        <gl-button-toggle data-ctx="button-toggle-pallet" [name]="'type'" [value]="3" formControlName="type">
          <div class="toggleContent">
            <gl-icon [name]="'palette'" class="iconTypePalette"></gl-icon>
            @if (!isQuick) {
              <span class="typeTitle">{{ 'pallet' | translate }}</span>
            }
          </div>
        </gl-button-toggle>
      </div>

      <button data-ctx="button-close" class="close" outline-icon-button (click)="close()">
        <gl-icon name="close"></gl-icon>
      </button>
    </div>
  </form>
  <div data-ctx="container-loading-space" class="container" @disabledInitial>
    @if (isListVisible) {
      <div class="leftContainer" @width>
        @if (!isQuick) {
          <div class="ownVehicleContainer">
            <div (click)="createOwnContainer()" class="ownVehicle" data-ctx="button-create-own-container">
              <div class="ownVehicleDescription">
                <div class="ownVehicleText">{{ 'create_own' | translate }}</div>
              </div>
              <gl-icon class="ownVehicleIcon" name="own-vehicle"></gl-icon>
            </div>
          </div>
        }
        <div class="loadingSpaceContainer" data-ctx="container-loading-space">
          <div class="loadingSpaceWrapper">
            @for (loadingSpace of filteredLoadingSpaces; track loadingSpace) {
              <div class="loadingSpace" data-ctx="button-loading-space">
                <gl-loading-space-list-element
                  (addSpace)="addSpace($event)"
                  (chosen)="onChosen($event)"
                  (edit)="editLoadingSpace($event)"
                  [hoverActive]="!isEdit"
                  [loadingSpace]="loadingSpace"
                ></gl-loading-space-list-element>
              </div>
            }
          </div>
        </div>
      </div>
    }

    @if (!isQuick) {
      <div class="heightLine" [class.removeLeftMargin]="!isListVisible">
        <div class="hideButton" (click)="listVisibleChanger()" data-ctx="button-hide">
          <gl-icon  name="undo" class="hideIcon" [class.rightIcon]="!isListVisible"></gl-icon>
        </div>
      </div>
    }

    <div class="rightContainer" [ngClass]="{ hideRightContainer: isQuick }">
      <div class="mainDimensions">
        <div class="leftMain">
          @if (chosenType <= 3) {
            <div class="visualization">
              <gl-loading-space-preview
                [height]="192"
                [loadingSpaceType]="loadingSpace"
                [width]="230"
                [project]="project"
                (clicked)="onPreviewClicked($event)"
              ></gl-loading-space-preview>
            </div>
          }
          @if (chosenType === 4) {
            <div class="visualization">
              <gl-air-container-preview [loadingSpace]="loadingSpace"></gl-air-container-preview>
            </div>
          }

          @if (chosenType !== 3 && project.workSpaces.length === 0 && getQuantity() < 2) {
            <div
              data-ctx="multiStopButton" class="multistop"
              [ngClass]="{'disabled': !isEdit}"
              (click)="openMultistop()"
              >
              <gl-icon class="multistopIcon" name="multistop"></gl-icon>
              {{ 'points_along_route' | translate }}
            </div>
          }
        </div>

        <div class="rightMain" (click)="enableEdit()">
          @if (chosenType === 1) {
            <gl-loading-space-dimensions
              #dimensions
              (formData)="onFormData($event, 'dimensions')"
              (submitEmitter)="submit($event)"
              [chosenLoadingSpace]="chosenLoadingSpace"
              [isEdit]="isEdit"
              [typeLoadingSpace]="chosenType"
              [savedStops]="savedStops"
            ></gl-loading-space-dimensions>
          }
          @if (chosenType === 2) {
            <gl-loading-space-dimensions
              #dimensions
              (formData)="onFormData($event, 'dimensions')"
              (submitEmitter)="submit($event)"
              [chosenLoadingSpace]="chosenLoadingSpace"
              [isEdit]="isEdit"
              [typeLoadingSpace]="chosenType"
              [savedStops]="savedStops"
            ></gl-loading-space-dimensions>
          }
          @if (chosenType === 3) {
            <gl-loading-space-pallet-dimensions
              #dimensions
              (formData)="onFormData($event, 'pallet')"
              (submitEmitter)="submit($event)"
              [chosenLoadingSpace]="chosenLoadingSpace"
              [isEdit]="isEdit"
              [typeLoadingSpace]="chosenType"
            ></gl-loading-space-pallet-dimensions>
          }
          @if (chosenType === 4) {
            <gl-loading-space-air-dimensions
              #dimensions
              (formData)="onFormData($event, 'air')"
              (submitEmitter)="submit($event)"
              [chosenLoadingSpace]="chosenLoadingSpace"
              [isEdit]="isEdit"
              [typeLoadingSpace]="chosenType"
              [savedStops]="savedStops"
            ></gl-loading-space-air-dimensions>
          }
        </div>
      </div>
      <div class="tabs">
        @if (chosenType <= 2) {
          <div (click)="openTab('set')" [ngClass]="{ active: isTabSet }" class="tab">
            <div class="tabText">{{ 'set' | translate }}</div>
          </div>
          @if (chosenType === 1) {
            <div
              (click)="openTab('axle-loads')"
              [ngClass]="{ active: isTabAxle }"
              class="tab"
              >
              <div class="tabText">{{ 'axle_loads' | translate }}</div>
            </div>
          }
          @if (chosenType === 2) {
            <div
              (click)="openTab('gravity-center')"
              [ngClass]="{ active: isTabGravityCenter }"
              class="tab"
              >
              <div class="tabText">{{ 'gravity_center' | translate }}</div>
            </div>
          }
          @if (chosenType === 1) {
            <div
              (click)="openTab('wheel-arches')"
              [ngClass]="{ active: isTabWheelArches }"
              class="tab"
              >
              <div class="tabText">{{ 'wheel_arches' | translate }}</div>
            </div>
          }
          @if (chosenType <= 3) {
            <div
              (click)="openTab('cooler')"
              [ngClass]="{ active: isTabCooler }"
              class="tab"
              >
              <div class="tabText">{{ 'cooling_unit' | translate }}</div>
            </div>
          }
          @if (chosenType === 2) {
            <div
              (click)="openTab('door-size')"
              [ngClass]="{ active: isTabDoorSize }"
              class="tab"
              >
              <div class="tabText">{{ 'door_size' | translate }}</div>
            </div>
          }
          @if (chosenType === 1) {
            <div
              (click)="openTab('variofloor')"
              [ngClass]="{ active: isTabVarioFloor }"
              class="tab"
              >
              <div class="tabText">{{ 'variofloor' | translate }}</div>
            </div>
          }
        }
        @if (chosenType === 3) {
          <!-- <div
          (click)="openTab('palletStacking')"
          [ngClass]="{ active: isPalletStacking }"
          class="tab"
          >
          <div class="tabText">{{ 'stacking' | translate }}</div>
        </div> -->
        <div
          (click)="openTab('palletVehicleLoading')"
          [ngClass]="{ active: isPalletVehicleLoading }"
          class="tab"
          >
          <div class="tabText">{{ 'vehicle_loading' | translate }}</div>
        </div>
      }
      @if (chosenType === 4) {
        <div
          (click)="openTab('gravity-center')"
          [ngClass]="{ active: isTabGravityCenter }"
          class="tab"
          >
          <div class="tabText">{{ 'gravity_center' | translate }}</div>
        </div>
      }
    </div>
    @if (isTabSet) {
      <div class="tabContent">
        <gl-loading-space-set
          #set
          (submitEvent)="submitEvent($event, 'Set')"
          [chosenLoadingSpace]="chosenLoadingSpace"
          [isEdit]="isEdit"
          [project]="project"
          [loadingSpace]="loadingSpace"
          [typeLoadingSpace]="chosenType"
        ></gl-loading-space-set>
      </div>
    }
    @if (isTabWheelArches) {
      <div class="tabContent">
        <gl-loading-space-wheel-arches
          #wheel
          (submitEvent)="submitEvent($event, 'Wheel')"
          [chosenLoadingSpace]="chosenLoadingSpace"
          [isEdit]="isEdit"
          [project]="project"
          [loadingSpace]="loadingSpace"
          [typeLoadingSpace]="chosenType"
        ></gl-loading-space-wheel-arches>
      </div>
    }
    @if (isTabAxle) {
      <div class="tabContent">
        <gl-loading-space-axle-loads
          #axleLoads
          (scrollDisable)="scrollDisable($event)"
          (submitEmitter)="axlesSave($event)"
          [isEdit]="isEdit"
          [loadForm]="dimensionsComponent?.form"
          [loadingSpace]="loadingSpace"
          [chosenLoadingSpace]="chosenLoadingSpace"
          >
        </gl-loading-space-axle-loads>
      </div>
    }
    @if (isTabGravityCenter) {
      <div class="tabContent">
        <gl-loading-space-gravity-center
          (submitEvent)="submitEvent($event, 'GravityCenter')"
          [chosenLoadingSpace]="chosenLoadingSpace"
          [isEdit]="isEdit"
          [loadingSpace]="loadingSpace"
          >
        </gl-loading-space-gravity-center>
      </div>
    }
    @if (isTabCooler) {
      <div class="tabContent">
        <gl-loading-space-cooler
          #cooler
          (submitEvent)="submitEvent($event, 'Cooler')"
          [chosenLoadingSpace]="chosenLoadingSpace"
          [isEdit]="isEdit"
          [project]="project"
          [loadingSpace]="loadingSpace"
          [typeLoadingSpace]="chosenType"
        ></gl-loading-space-cooler>
      </div>
    }
    @if (isTabDoorSize) {
      <div class="tabContent">
        <gl-loading-space-door-size
          #door
          (submitEvent)="submitEvent($event, 'Door')"
          [chosenLoadingSpace]="chosenLoadingSpace"
          [isEdit]="isEdit"
          [project]="project"
          [loadingSpace]="loadingSpace"
        ></gl-loading-space-door-size>
      </div>
    }
    @if (isTabVarioFloor) {
      <div class="tabContent">
        <gl-loading-space-vario-floor
          #varioFloor
          (submitEvent)="submitEvent($event, 'VarioFloor')"
          [chosenLoadingSpace]="chosenLoadingSpace"
          [isEdit]="isEdit"
          [project]="project"
          [loadingSpace]="loadingSpace"
          [typeLoadingSpace]="chosenType"
        ></gl-loading-space-vario-floor>
      </div>
    }
    @if (isPalletStacking) {
      <div class="tabContent">
        <gl-loading-space-pallet-stacking
          (submitEvent)="submitEvent($event, 'PalletStacking')"
          [isEdit]="isEdit"
          [loadingSpace]="loadingSpace"
          [chosenLoadingSpace]="chosenLoadingSpace"
        ></gl-loading-space-pallet-stacking>
      </div>
    }
    @if (isPalletVehicleLoading) {
      <div class="tabContent">
        <gl-loading-space-pallet-vehicle-loading
          (submitEvent)="submitEvent($event, 'PalletVehicle')"
          [isEdit]="isEdit"
          [loadingSpace]="loadingSpace"
          [chosenLoadingSpace]="chosenLoadingSpace"
        ></gl-loading-space-pallet-vehicle-loading>
      </div>
    }
  </div>
</div>
</div>

@if (isEditMultistop) {
  <gl-multi-stop-edit
    [savedStops]="savedStops"
    (closeWindow)="openMultistop()"
    (submitStops)="submitStops($event)"
  ></gl-multi-stop-edit>
}
